import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { conditionalValidator } from '../../util/calsoft-validators';

@Component({
  selector: 'calsoft-message',
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.scss']
})
export class MessageComponent implements OnInit {

  today: Date = new Date();

  @Input() data: any;

  @Input() product: any;

  @Input() configproduct: any;


  
  @Output() finalValue: EventEmitter<any> = new EventEmitter<any>();


  constructor(private _formBuilder: FormBuilder,) { }
  messageRequired:any=1;

  ngOnInit() {

    let message=null;
    if ((this.configproduct.type == 'Configurable'
      || this.configproduct.type == 'Variants')
      && this.configproduct.configurableProductDropdown != null) {
      if (this.configproduct.entityId != this.product.entityId) {
        message= localStorage.getItem('message'+ this.configproduct.entityId);
      }else{
        message=localStorage.getItem('message'+ this.product.entityId);
      }
      }else{
        message=  localStorage.getItem('message'+ this.product.entityId);
      }
    if(this.data.messageRequired==null){
     
      this.messageRequired=0;
    }
    this.firstFormGroup = this._formBuilder.group({
      pickUp: [''],

      additionalMessgae: [
        null,
        Validators.compose([
  
          conditionalValidator(
            (() => this.messageRequired==1),
            Validators.required,
          ),
         
  
        ])
      ],

    })
    this.firstFormGroup.get('additionalMessgae').valueChanges.subscribe(value => {
      if ((this.configproduct.type == 'Configurable'
      || this.configproduct.type == 'Variants')
      && this.configproduct.configurableProductDropdown != null) {
      if (this.configproduct.entityId != this.product.entityId) {
        localStorage.setItem('message'+ this.configproduct.entityId, value);
      }else{
        localStorage.setItem('message'+ this.product.entityId, value);
      }
      }else{
        localStorage.setItem('message'+ this.product.entityId, value);
      }

    });

    this.firstFormGroup.get('pickUp').valueChanges.subscribe(value => {
      if ((this.configproduct.type == 'Configurable'
      || this.configproduct.type == 'Variants')
      && this.configproduct.configurableProductDropdown != null) {
      if (this.configproduct.entityId != this.product.entityId) {
        localStorage.setItem('pickUp'+ this.configproduct.entityId, value);
      }else{
        localStorage.setItem('pickUp'+ this.product.entityId, value);
      }
      }else{
        localStorage.setItem('pickUp'+ this.product.entityId, value);
      }
    });

  if(message!=null){

    this.firstFormGroup.get("additionalMessgae").setValue(message);
  }
    
  }

  firstFormGroup: FormGroup;



}
